import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Logout from './Logout';

function UserInfo({ name, upn }) {
  if (!name) {
    return null;
  }

  return (
    <Col>
      <div>{name}</div>
      <div>[{upn}]</div>
      <Logout />
    </Col>
  );
}

UserInfo.propTypes = {
  name: PropTypes.string,
  upn: PropTypes.string,
};

export default UserInfo;
